import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import store from '@/store/index'

export const redirectIfTokenExists = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (isAuthenticated) next()
  else next({ path: 'auth', query: { redirect: to.path } })
}

/**
 * Admin-only routes (SMN-67, finding 3.9).
 *
 * These guards were written and then commented out in `protected.routes.ts`, so
 * /core-usage, /user-admin and /dns-options were reachable by any signed-in
 * account -- support included.
 *
 * This is UX, not a boundary, and it is worth being clear which: a router guard
 * runs in the browser and anyone can step past it. What stops support reading or
 * changing anything is the server, which denies by default and has since SMN-36.
 * The guard's job is that the portal stops offering pages whose every request
 * will come back 403.
 *
 * It reads `auth/isAdmin`, which since SMN-67 derives from the role claim in the
 * signed access token rather than from a cookie the page wrote to itself.
 */
export const requireAdmin = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (store.getters['auth/isAdmin']) next()
  else next({ path: '/' })
}

export const redirectIfTokenExpired = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (!isAuthenticated) next()
  else next({ path: from.path })
}
